export default __webpack_public_path__ + "static/media/SRI.16ddde5e.jpg";